"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-59a4b484"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "text-left flex-column generator-container" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", null, "AIでシフトを作成してみましょう。"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "業務管理ページで選択した業務と設定に基づいて、AIが月間のシフトを自動作成します。各業務に割り当てるスタッフや1日の必要人数も考慮されます。")
], -1 /* HOISTED */));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", null, "スピード", -1 /* HOISTED */));
const _hoisted_4 = { class: "speed-labels flex-justify-between" };
const _hoisted_5 = { class: "track-wrapper" };
const _hoisted_6 = { class: "speeds" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex-justify-between mt-1 font-sm" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "素早く作成"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "詳細まで考慮して作成")
], -1 /* HOISTED */));
const _hoisted_8 = { class: "flex-column flex-gap" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("h5", { class: "m-0" }, "シフトの微調整", -1 /* HOISTED */));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "シフトをより最適化するために、下のテキストボックスに追加条件を入力できます。", -1 /* HOISTED */));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "font-sm" }, "※AIが作成した内容は、自動処理の性質上、誤った日付や意図しない割り当てが含まれる可能性があります。内容を確認のうえ、必要に応じて修正してください。", -1 /* HOISTED */));
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
const MIN = 2;
const MAX = 8;
const STEP = 2;
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIShiftGenerator',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.autoAIViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const speeds = [2, 4, 6, 8]; // minutes
        const selectedSpeed = (0, vue_3.computed)({
            get: () => viewModel?.value.speed || 2,
            set: (val) => presenter?.setSpeed(Number(val)),
        });
        const instructions = (0, vue_3.computed)({
            get: () => viewModel?.value.instructions || '',
            set: (text) => presenter?.setIntructions(text),
        });
        const toPercent = (value) => {
            return ((value - MIN) / (MAX - MIN)) * 100;
        };
        const percent = (0, vue_3.computed)(() => {
            return toPercent(selectedSpeed.value);
        });
        const displaySpeeds = (0, vue_3.computed)(() => {
            return speeds.filter(t => t !== selectedSpeed.value);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (0, vue_2.createElementVNode)("div", null, [
                    _hoisted_3,
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(speeds, (s) => {
                            return (0, vue_2.createElementVNode)("span", {
                                key: s,
                                class: (0, vue_2.normalizeClass)({ active: selectedSpeed.value === s })
                            }, (0, vue_2.toDisplayString)(s) + "分 ", 3 /* TEXT, CLASS */);
                        }), 64 /* STABLE_FRAGMENT */))
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("div", {
                            class: "track",
                            style: (0, vue_2.normalizeStyle)({ '--fill': percent.value + '%' })
                        }, null, 4 /* STYLE */),
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(displaySpeeds.value, (t) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                    key: t,
                                    class: (0, vue_2.normalizeClass)(["speed", { 'speed-past': t < selectedSpeed.value }]),
                                    style: (0, vue_2.normalizeStyle)({ left: toPercent(t) + '%' })
                                }, null, 6 /* CLASS, STYLE */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            class: "range",
                            type: "range",
                            min: MIN,
                            max: MAX,
                            step: STEP,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSpeed).value = $event))
                        }, null, 512 /* NEED_PATCH */), [
                            [vue_2.vModelText, selectedSpeed.value]
                        ])
                    ]),
                    _hoisted_7
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                        class: "form-input generator-text",
                        rows: "5",
                        placeholder: "スタッフ１は9/15~9/20に有休を取得\nスタッフ４とスタッフ７は同じ業務を割り当てない\n業務Aのスタッフ割り当てを優先する\n業務Cと業務Dをできるだけ均等に分配する",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((instructions).value = $event))
                    }, null, 512 /* NEED_PATCH */), [
                        [vue_2.vModelText, instructions.value]
                    ])
                ]),
                _hoisted_11
            ]));
        };
    }
});
